import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import { COMPANY_SETTINGS_REWARDS } from 'const/translations/SalaryCompanySettings';
import { getRewardTypeText } from 'modules/SalaryModule/Rewards/utils';
// import { EditableContext } from './context';
import Styles from './RewardsTable.module.css';

const { Option } = Select;

const propTypes = {
  inputType: PropTypes.string,
  children: PropTypes.node,
  editing: PropTypes.bool,
  dataIndex: PropTypes.array,
  record: PropTypes.object,
  inputMaxLength: PropTypes.number,
};

export const EditableCell = ({
  inputType,
  editing,
  dataIndex,
  inputMaxLength,
  record,
  children,
  ...props
}) => {
  // const form = useContext(EditableContext);

  const getInput = useCallback(() => {
    if (inputType === 'text') {
      return <Input />;
    }

    return (
      <Select
        className={Styles.select}
        classNames={{ popup: { root: Styles.dropdown } }}
      >
        {COMPANY_SETTINGS_REWARDS.REWARD_TYPE_OPTIONS.map(
          ({ label, value }) => (
            <Option key={value} value={value}>
              {label || value}
            </Option>
          )
        )}
      </Select>
    );
  }, [inputType]);

  const name = dataIndex?.[1];
  const initialValue = record?.[dataIndex?.[0]]?.[dataIndex?.[1]];

  const displayValue = dataIndex?.includes('type')
    ? getRewardTypeText(record?.reward?.type)
    : children;

  return (
    <td {...props}>
      {editing ? (
        <Form.Item
          name={name}
          style={{ margin: 0 }}
          className={Styles.input}
          initialValue={initialValue}
          rules={[
            {
              required: true,
              max: inputMaxLength,
            },
          ]}
        >
          {getInput()}
        </Form.Item>
      ) : (
        displayValue
      )}
    </td>
  );
};

EditableCell.propTypes = propTypes;
